/**
 * @param {string} str - the original image URL
 * @param {string} filter - The filter to get suffixed to the image URL
 */
export default function updateimageURL(str, filter) {
  const [fullURL, queryParams] = str.split('?');
  const [cdn, url] = fullURL.split('cdn.shopify.com');

  const parts = url.split('.');
  const lastElem = parts.length - 1;

  const updatedURL = parts
    .map((m, i) => {
      // Add our Filter onto the last elem IE before the file type
      if (i === lastElem - 1) {
        return `${m}_${filter}`;
      }
      return m;
    })
    .join('.');

  const newURL = [cdn, updatedURL].join('cdn.shopify.com');
  return [newURL, queryParams].join('?');
}
